import type { ButtonBaseProps } from '@mui/material';
import { ButtonBase, Typography } from '@mui/material';
import type { ComponentProps } from 'react';

export interface LinkButtonProps extends ButtonBaseProps {
  variant?: ComponentProps<typeof Typography>['variant'];
}

/**
 * render a link that has no href-target but onClick doings.
 * Ripple is disabled and link like typography is added.
 * @param props
 * @returns JSX.Element
 */
export const LinkButton: React.FC<LinkButtonProps> = ({ variant = 'body2', ...props }) => (
  <ButtonBase {...props} disableRipple>
    <Typography variant={variant} sx={{ textDecoration: 'underline' }} component="span">
      {{ ...props }.children}
    </Typography>
  </ButtonBase>
);
